// src/components/common/DeleteButton.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@/icons';
import './DeleteButton.css';

interface DeleteButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({
  onClick,
  disabled = false,
  className = '',
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`delete-button ${className}`}
    >
      <FontAwesomeIcon icon={faTrashCan} /> Excluir
    </button>
  );
};

export default DeleteButton;
